import { render, staticRenderFns } from "./configPenaltyRules.vue?vue&type=template&id=632a06c9&scoped=true"
import script from "./configPenaltyRules.vue?vue&type=script&lang=js"
export * from "./configPenaltyRules.vue?vue&type=script&lang=js"
import style0 from "./configPenaltyRules.vue?vue&type=style&index=0&id=632a06c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632a06c9",
  null
  
)

export default component.exports